<template>
  <div id="app">
    <ScrollManager></ScrollManager>
    <header>
      <div class="logo">
        <picture>
          <source srcset="@/assets/baunfire@2x.png 2x, @/assets/baunfire.png 1x">
          <img src="@/assets/baunfire.png" alt="Baunfire logo">
        </picture>
      </div>
      <div class="logo-white hide">
        <picture>
          <source srcset="@/assets/baunfire_white@2x.png 2x, @/assets/baunfire_white.png 1x">
          <img src="@/assets/baunfire_white.png" alt="Baunfire logo"> 
        </picture>
      </div>
      <div class="symbol hide" v-on:click="toHome">
        <picture>
          <source srcset="@/assets/logo@2x.png 2x, @/assets/logo.png 1x">
          <img src="@/assets/logo.png" alt="Baunfire symbol">          
        </picture>
      </div>
    </header>
    <nav>
      <a href="#" v-on:click="toAbout" class="button-about">
        <div class="default">About</div>
        <div class="active">Close</div>
      </a>
    </nav>
    <router-view/>
    <About ref="about"></About>
    <CustomCursor></CustomCursor>
  </div>
</template>

<script>
import CustomCursor from "@/components/CustomCursor.vue";
import ScrollManager from "@/components/ScrollManager.vue";
import About from "@/views/About.vue";

export default {
    name: "app",
    data: function() {
        return {
            key: null
        };
    },
    components: {
        CustomCursor,
        ScrollManager,
        About
    },
    methods: {
        toAbout: function(e) {
            e.preventDefault();

            if (this.$refs.about.open) {
                this.$refs.about.hide();
                this.$el
                    .querySelector(".button-about")
                    .classList.remove("show");
            } else {
                this.$refs.about.show();
                this.$el.querySelector(".button-about").classList.add("show");
            }
        },
        toHome: function() {
            this.$store.commit("toHome", {
                home: true
            });
        }
    }
};
</script>

<style lang="scss">
#app {
    height: 100vh;
    overflow: hidden;
}

header {
    position: fixed;
    top: 52px;
    left: 52px;
    z-index: 12;

    @media ($mobile-screen) {
        top: 26px;
        left: 26px;
    }

    &.difference {
        mix-blend-mode: difference;
    }
}

.logo {
    transition: opacity 0.65s $primary-ease;
    pointer-events: none;

    &.hide {
        opacity: 0;

        @media ($mobile-screen) {
            transition: opacity 0.65s $primary-ease, transform 0.1s none 0.65s;
            transform: translate3d(0, -500px, 0);
        }
    }

    &-white {
        transition: opacity 0.65s $primary-ease;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;

        &.hide {
            opacity: 0;
        }
    }
}

.symbol {
    transition: opacity 0.65s $primary-ease;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    &.hide {
        opacity: 0;
        pointer-events: none;
    }
}

nav {
    @include playfair-black;
    position: fixed;
    top: 29px;
    right: 70px;
    z-index: 12;
    font-size: 20px;
    transition: color 0.65s $primary-ease;
    transform: rotate(-90deg);
    transform-origin: bottom right;

    @media ($mobile-screen) {
        font-size: 15px;
        top: 10px;
        right: 30px;
    }

    &.white {
        color: white;
    }

    &.difference {
        mix-blend-mode: difference;
    }

    .button-about {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        overflow: hidden;
        position: relative;
        height: 20px;
        line-height: 1;
        // -webkit-font-smoothing: subpixel-antialiased;

        @media ($mobile-screen) {
            height: 15px;
        }

        .default {
            transition: transform 0.55s $primary-ease;
        }

        .active {
            transition: transform 0.55s $primary-ease;
        }

        &.show {
            .default,
            .active {
                transform: translate3d(0, -100%, 0);
            }
        }
    }
}
</style>